

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

import RichTextTemplate from "@/components/Controls/RichTextTemplate.vue"
import vSelect from "vue-select"

import { CaseColumn } from "@/types/caseColumns"
import { FormatSection, Layout, LayoutSection } from "@/types/format"

@Component({
	components: {
		"rich-template": RichTextTemplate,
		"v-select": vSelect
	}
})
export default class FormatSectionSetup extends Vue {
	@Prop({ default: () => [] })
	value!: FormatSection[] | null

	@Prop({ required: true })
	layout!: Layout | null

	@Prop({ required: true })
	fields!: CaseColumn[]

	@Prop({ required: true })
	additionalFields!: { id: string, label: string }[]

	activeSection: LayoutSection | null = null

	get sectionsByKey (): { [key: string]: FormatSection } {
		const sectionsByKey = this.value ? this.value.toDictionary("layoutSection") : {}

		let valueChanged = false
		if (this.layout && this.layout.sections) {
			this.layout.sections.forEach(section => {
				if (!sectionsByKey[section.key]) {
					sectionsByKey[section.key] = {
						layoutSection: section.key,
						title: "",
						template: ""
					}
					valueChanged = true
				}
			})
		}

		if (valueChanged) {
			this.$emit("input", Object.values(sectionsByKey))
		}

		return sectionsByKey
	}

	mounted () {
		if (this.layout) {
			this.onLayoutChanged(this.layout)
		}
	}

	@Watch("layout")
	onLayoutChanged (newLayout: Layout | null) {
		if (newLayout && newLayout.sections.length > 2) {
			if (!this.activeSection || !newLayout.sections.some(s => s.key === this.activeSection!.key)) {
				this.activeSection = newLayout.sections[0]
			}
		} else {
			this.activeSection = null
		}
	}
}

